import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import {Col} from "react-materialize";
import Moment from 'react-moment';
import './scrollTopButton.css';
import RatioOverflowTableWrapper
    from "../../../components/styled-components/ratio-overflow-table-wrapper/RatioOverflowTableWrapper";

class ApiLogInternalTable extends Component {
    getIcon(sortDirection) {
        switch (sortDirection) {
            case "ASC":
                return 'arrow_downward';
            case "DESC":
                return 'arrow_upward';
            case false:
                return 'swap_vert'
        }
    }

    generateHeader() {
        return (
            this.props.headersNames.map((headerName) => {
                return <TableHeaderColumn
                    className="clickable"
                    key={headerName}
                    headername={headerName}
                    style={this.getStyle(headerName)}
                >
                    {headerName}
                    <i className="material-icons right lightgrey">
                        {this.getIcon(this.props.sortingState[this.props.getPropertyNameFromDisplayName(headerName)])}
                    </i>
                </TableHeaderColumn>
            })
        );
    }

    getStyle = (property) => {
        switch (property) {
            case 'Logboek-ID':
            case 'Offerte ID':
            case 'Succesvol':
            case 'Acties':
            case 'id':
            case 'quotationId':
            case 'status':
            case 'actions':
                return {width: '10%'};
            case 'Verzoektype':
            case 'Geïnitieerd door':
            case 'Aangemaakt':
            case 'Gewijzigd':
            case 'requestType':
            case 'createdAt':
            case 'updatedAt':
            case 'author':
                return {width: '20%'};
            default:
                return {}
        }
    };

    generateRowValue = (row, property) => {
        switch (property) {
            case 'status':
                return this.generateSuccessStatus(row['status']);
            case 'createdAt':
                return row[property];
            case 'updatedAt':
                return row[property];
            default:
                return row[property];
        }
    };

    generateRow(row) {
        let properties = this.props.propertiesToShow;

        return (
            <TableRow key={row.id}>
                {properties.map(property =>
                    <TableRowColumn key={property} style={this.getStyle(property)}>
                        <div>
                            {this.generateRowValue(row, property)}
                        </div>
                    </TableRowColumn>
                )}

                {<TableRowColumn style={this.getStyle('actions')}>{this.props.actionsColumn(row)}</TableRowColumn>}
            </TableRow>
        );
    }

    generateSuccessStatus(status) {
        if (status) {
            return <Col s={12} className="finishedStatus"> Succesvol </Col>;
        } else {
            return <Col s={12} className="dangerStatus"> Mislukt </Col>;
        }
    }

    render() {
        return (
            <RatioOverflowTableWrapper>
                <Table
                    onRowSelection={this.props.handleRowSelection}
                    selectable={false}
                >
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow onCellClick={this.props.onHeaderClick}>
                            {
                                this.generateHeader()
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {
                            this.props.rows.map(row => this.generateRow(row))
                        }
                    </TableBody>
                </Table>
            </RatioOverflowTableWrapper>
        );
    }
}

ApiLogInternalTable.propTypes = {
    headersNames: PropTypes.array.isRequired,
    propertiesToShow: PropTypes.array.isRequired,
    handleRowSelection: PropTypes.func,
    rows: PropTypes.array.isRequired,
    onHeaderClick: PropTypes.func,
    displayStatusInRow: PropTypes.func,
    sortingState: PropTypes.any,
    getPropertyNameFromDisplayName: PropTypes.func
    // actionsColumn: PropTypes.any,
};

export default ApiLogInternalTable;
